import { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import CircleLoader from "../../global/Loader/CircleLoader";
import { Box, Button, FormControl, FormLabel, InputAdornment, TextField } from "convertupleads-theme";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";
import companyCreditBalanceService from "../../services/companyCreditBalance.service";
import { selectCurrencyState } from "../../state/common/commonSelector";

const CompanyCreditBalance = ({ onClose, companyInfo }) => {
  const [loading, setLoading] = useState(true);
  const { data: currencies = [] } = useSelector(selectCurrencyState);

  const {
    register,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      balance: 0,
      currency: null,
    },
  });

  /* ---------------- Load initial data ---------------- */
  useEffect(() => {
    setLoading(true);

    companyCreditBalanceService
      .getCompanyCreditBalance({ companyId: companyInfo.id })
      .then((res) => {
        if (res.status) {
          reset({
            balance: res.data.balance || 0,
            currency: currencies.find((c) => c.value === res.data.currency) || currencies[0],
          });
        }
      })
      .finally(() => setLoading(false));
  }, [companyInfo.id, currencies, reset]);

  /* ---------------- Submit ---------------- */
  const onSubmit = (data) => {
    console.log("Form data:", data);
    companyCreditBalanceService
      .updateCompanyCreditBalance({
        companyId: companyInfo.id,
        balance: data.balance,
        currency: data.currency?.value,
      })
      .then((res) => {
        if (res.status) {
          showSuccessToaster(res.message);
          onClose();
        } else {
          showErrorToaster(res.message);
        }
      });
  };

  const selectedCurrency = watch("currency");

  if (loading) return <CircleLoader />;

  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* -------- Credit Balance -------- */}
      <FormControl>
        <FormLabel>Credit Balance</FormLabel>
        <TextField
          size="small"
          type="number"
          step="0.01"
          {...register("balance", {
            required: "Balance is required",
            valueAsNumber: true,
          })}
          error={!!errors.balance}
          helperText={errors.balance?.message}
          InputProps={{
            startAdornment: <InputAdornment position="start">{selectedCurrency?.value || "$"}</InputAdornment>,
          }}
        />
      </FormControl>

      {/* -------- Currency -------- */}
      <FormControl>
        <FormLabel>Currency</FormLabel>
        <Controller
          name="currency"
          control={control}
          rules={{ required: "Currency is required" }}
          render={({ field }) => (
            <Select
              {...field}
              options={currencies}
              isSearchable={false}
              className="select-dropdown-menu select-dropdown-menu-custom"
              classNamePrefix="select-dropdown-styles"
              placeholder="Select currency"
            />
          )}
        />
      </FormControl>

      {/* -------- Actions -------- */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button type="submit" variant="contained">
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default CompanyCreditBalance;
